"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Destroy = Destroy;
exports.Initialize = Initialize;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable no-undef */
function Initialize(_x, _x2) {
  return _Initialize.apply(this, arguments);
}
function _Initialize() {
  _Initialize = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(plaidConfig, handleTokenExpiry) {
    var handler;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.Plaid) {
              _context.next = 8;
              break;
            }
            _context.next = 3;
            return Plaid.create(plaidConfig);
          case 3:
            handler = _context.sent;
            window.lc_plaid = {
              handler: handler
            };
            handler.open();
            _context.next = 9;
            break;
          case 8:
            handleTokenExpiry({
              lc_error: {
                code: 'PLAID-UNAVAILABLE',
                msg: 'Plaid is unavailable on window'
              }
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _Initialize.apply(this, arguments);
}
function Destroy() {
  return _Destroy.apply(this, arguments);
}
function _Destroy() {
  _Destroy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window && window.lc_plaid && window.lc_plaid.handler && window.lc_plaid.handler.destroy) {
              window.lc_plaid.handler.destroy();
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _Destroy.apply(this, arguments);
}
